
import { useGetAllProjectIdsQuery } from "services/project/projectApi";
import ProjectLens from "./ProjectLens";

const GeneralContent = 1;
const EroContent = 2; 

const Projects = ()  => {
  let tags: Array<number>  = window.location.hostname.includes('sukebei') ? [ EroContent ] : [];

  const { data: projectIds, error, isLoading } = useGetAllProjectIdsQuery({ tagIds: [...tags] });


  if (isLoading) {
    return null;
  }

  if (!projectIds) {
    return null;
  }

  return (
    <ProjectLens projectIds={projectIds} />
  );
}


export default Projects;